// extracted by mini-css-extract-plugin
module.exports = {"Video":"VideoThumbnail_Video__3eQOG"};